import { render } from "./AddressComponent.vue?vue&type=template&id=3f023f4c"
import script from "./AddressComponent.vue?vue&type=script&lang=js"
export * from "./AddressComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__